import React from 'react';
interface SectionProps {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'white' | 'tint' | 'deep';
  width?: 'content' | 'narrow';
  children: React.ReactNode;
}
const toneClasses: Record<NonNullable<SectionProps['tone']>, string> = {
  white: 'bg-white text-ink',
  tint: 'bg-blue-50 text-ink',
  deep: 'bg-blue-900 text-white'
};
export function Section({
  id,
  eyebrow,
  title,
  intro,
  tone = 'white',
  width = 'content',
  children
}: SectionProps) {
  const hasHeader = Boolean(eyebrow || title || intro);
  return <section id={id} className={`w-full py-16 md:py-24 ${toneClasses[tone]}`} data-id="element-214" data-mp="2pv92n0o8jcp">
      <div className={`mx-auto w-full px-5 md:px-8 ${width === 'narrow' ? 'max-w-narrow' : 'max-w-content'}`} data-id="element-215" data-mp="2nr4s3yv1ibw">
        {hasHeader && <header className="mx-auto max-w-narrow text-center" data-id="element-216" data-mp="vcy61app8m0u">
            {eyebrow && <p className={`mb-4 font-display text-xs font-extrabold uppercase tracking-[0.18em] ${tone === 'deep' ? 'text-gold-300' : 'text-gold-600'}`} data-id="element-217" data-mp="10610rm67q1im">
                {eyebrow}
              </p>}
            {title && <h2 className="font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight md:text-5xl" data-id="element-218" data-mp="38eglbux12mzm">
                {title}
              </h2>}
            {intro && <p className={`mx-auto mt-5 max-w-2xl text-lg md:text-xl ${tone === 'deep' ? 'text-blue-100' : 'text-blue-900/70'}`} data-id="element-219" data-mp="3i9s4cpfgygd6">
                {intro}
              </p>}
          </header>}
        <div className={hasHeader ? 'mt-12 md:mt-16' : ''} data-id="element-220" data-mp="3nb7n2au6case">{children}</div>
      </div>
    </section>;
}